import { AddPopoutSource, addPopoutV2 } from 'owa-popout-v2';
import { CALENDAR_POPOUT_OPTIONS } from './popoutCalendarCompose';

export default function popoutCalendarReadingPane(itemId: string, source?: AddPopoutSource) {
    const route = 'read/' + encodeURIComponent(itemId);
    addPopoutV2('calendar', route, null /*data*/, CALENDAR_POPOUT_OPTIONS);
}
